module.exports = __webpack_public_path__ + "img/nosotros_16-9_960.eab97e29.jpg";